const quickAbout = {
    status: 'מהנדס AI ב-Pentera',
    title: 'תומר הללי',
    role: 'מהנדס AI',
    description:
        'אני בונה סוכני LLM ומערכות RAG בפרודקשן — ואת תשתית ה-AWS שמריצה אותם. אורקסטרציה מרובת סוכנים על LangGraph ו-Bedrock, retrieval בקנה מידה גדול, ומתחת לכל זה שער LLM, מערכי הערכה ו-Terraform.',
    viewWork: 'לפרויקטים שלי',
    resume: 'הורדת קורות חיים',
    currently: 'כרגע',
};

export default quickAbout;
